import { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';

interface Props {
  defaultUrl: string
  open: boolean
  handleClose: () => void
  handleSave: (url: string) => void
}

const Index = (props: Props) => {
  const {
    defaultUrl, open, handleClose, handleSave,
  } = props;
  const [pageUrl, setPageUrl] = useState('');

  useEffect(() => {
    if (defaultUrl === '') {
      return;
    }

    setPageUrl(defaultUrl);
  }, [defaultUrl]);

  // モーダルが閉じられた時に、タイトルをリセットします
  useEffect(() => () => {
    if (open) {
      return;
    }
    setPageUrl('');
  }, [open]);

  return (
    <ModalComponent
      title="QRダウンロード"
      confirmButtonText="生成する"
      onConfirm={() => handleSave(pageUrl)}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      QRダウンロード
    </ModalComponent>
  );
};

export default Index;
